module.exports = __webpack_public_path__ + "static/media/wuxi.e16ed20d.png";